import {useContext} from 'react';
import {UserAttributesContext} from '../context/UserAttributesContext';

export const useUserAttributes = () => useContext(UserAttributesContext);
